/**
 * Apply one trip-level status to package, components, itinerary, and add-ons before save.
 * Departure dates keep their own booking lifecycle status.
 */
export const applyTripStatusToFormData = (formData, status) => {
    if (!formData || !status) return formData;

    const next = { ...formData };

    if (next.packages) {
        next.packages = { ...next.packages, status };
    }

    if (next.services?.services?.length) {
        next.services = {
            ...next.services,
            services: next.services.services.map((item) => ({ ...item, status })),
        };
    }

    if (next.itineraries && Object.keys(next.itineraries).length > 0) {
        next.itineraries = { ...next.itineraries, status };
    }

    if (next.addons?.addons?.length) {
        next.addons = {
            ...next.addons,
            addons: next.addons.addons.map((item) => ({ ...item, status })),
        };
    }

    return next;
};
